<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light navbar-wrapper-inner">
      <router-link to="/">
        <img
          id="mainLogo"
          ref="mainLogo"
          class="main-logo"
          src="@/assets/logo.png"
          alt=""
          @click="toggleShowNavbar"
        >
        <h3
          id="mainHeader"
          class="main-header"
        >
          find your own <br> <img
            id="mobileLogo"
            ref="mobileLogo"
            class="inner-header"
            src="@/assets/logo_bubble.png"
            alt=""
          >
        </h3>
        <h3
          id="mainHeaderMobile"
          class="main-header-mobile"
        >
          <img
            id="mobileLogo"
            ref="mobileLogo"
            class="mobile-logo"
            src="@/assets/logo_bubble.png"
            alt=""
          >
        </h3>
      </router-link>
      <div class="nav-cart-wrapper">
        <a @click="goTo('Cart')">
          <b-icon-minecart />
          <span class="cart-icon-amount">{{ cart.products.length ? cart.products.length : '' }}</span>
        </a>
      </div>
      <button
        class="navbar-toggler hamburger"
        type="button"
        @click="handleHamburgerClick()"
      >
        <span class="navbar-toggler-icon" />
      </button>
    </nav>
    <div
      id="nav-bg-click"
      class="nav-menu-options-base"
      :class="{'nav-menu-options-open': isMobile && showMenu,
               'nav-menu-options-close': !showMenu}"
      @click="(e) => handleDarkBgClick(e)"
    >
      <div class="nav-white-bg">
        <div class="nav-menu-list">
          <div class="nav-menu-element">
            <a
              class="nav-link link-text"
              @click="goTo('About')"
            >
              <span>{{ strings.navbar.about_ }}</span>
            </a>
          </div>
          <div class="nav-menu-element">
            <a
              class="nav-link link-text"
              @click="goTo('Lookbook')"
            >
              <span>{{ strings.navbar.lookBook_ }}</span>
            </a>
          </div>
          <div class="nav-menu-element">
            <a
              class="nav-link link-text"
              @click="goTo('Shop')"
            >
              <span>{{ strings.navbar.shop_ }}</span>
            </a>
          </div>
          <div class="nav-menu-element">
            <a
              class="nav-link link-text"
              @click="goTo('Spotfinder')"
            >
              <span>Spotfinder</span>
            </a>
          </div>
          <div class="nav-menu-element">
            <a
              class="nav-link link-text"
              @click="goTo('Contact')"
            >
              <span>{{ strings.navbar.contact_ }}</span>
            </a>
          </div>
          <div class="nav-menu-element cart-element">
            <a
              class="nav-link link-text"
              @click="goTo('Cart')"
            >
              <Cart />
            </a>
          </div>
          <div class="nav-menu-element lang-element">
            <a
              class="nav-link link-text"
              @click="changeLang(lang === 'pl' ? 'en' : 'pl')"
            >
              <span>{{ (lang === 'pl' ? 'en' : 'pl') }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Cart from '@/components/shop/Cart.vue'

export default {
  name: 'Navbar',
  components: {
    Cart
  },
  data () {
    return {
      showMenu: false,
      isMobile: false
    }
  },
  computed: {
    ...mapGetters([
      'cart', 'strings', 'lang'
    ]),
    cartUpdate () {
      return Object.assign({}, this.cart)
    }
  },
  methods: {
    ...mapActions(['toggleShowNavbar', 'setLang']),
    openMobileMenu () {
      this.isMobile = true
      this.showMenu = true
    },
    hideMenu () {
      this.showMenu = false
    },
    handleHamburgerClick () {
      if (!this.showMenu) this.openMobileMenu()
      else this.hideMenu()
      this.$store.dispatch('toggleMenuVisibleWhileMobile')
    },
    goTo (name) {
      if (this.isMobile) this.hideMenu()
      this.$router.push({ name })
      this.$store.dispatch('hideMenuWhenMobile')
    },
    handleDarkBgClick (e) {
      if (e.target.id === 'nav-bg-click') {
        this.hideMenu()
        this.$store.dispatch('hideMenuWhenMobile')
      }
    },
    changeLang (lang) {
      this.setLang(lang)
    }
  }
}
</script>

<style scoped lang="scss">
.navbar-wrapper-inner {
  position: fixed;
  z-index: 1001;
  background-color: #ffffff;
  width: 100%;
}
.header-wrapper {
  width: 100%;
}
.main-logo {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 70px;
  z-index: 1001;
}
.main-header {
  display: none;
}
.mobile-logo {
  width: 130px;
}
.inner-header {
  display: block;
  color: rgb(129, 35, 153);
}
.hamburger {
  border: none;
  color: #000000;
  outline: none;
  margin-top: -4px;
  margin-right: -10px;
}
.nav-cart-wrapper {
  position: fixed;
  right: 80px;
  top: 5px;
  font-size: 1.7rem;
}
.cart-icon-amount {
  font-size: 0.7rem;
  position: relative;
  top: -8px;
  left: -20px;
  font-weight: bold;
}
.nav-menu-options-base {
  height: 200vh;
  width: 0;
  transition-duration: 0.5s;
  position: fixed;
}
.nav-menu-options-open {
  z-index: 1000;
  background-color: rgba($color: #000000, $alpha: 0.4);
  width: 100%;
  opacity: 1;
}
.nav-menu-options-close {
  transform: translateX(-100vw);
  opacity: 0;
}
.nav-white-bg {
  width: 75%;
  height: 100%;
  background-color: #ffffff;
}
.nav-menu-list {
  padding-top: 80px;
  text-align: left;
}
.nav-menu-element {
  margin-left: 10px;
  font-size: 1rem;
  letter-spacing: 2px;
  color: #000000;
}
.lang-element {
  margin-top: 30px,
}

.nav-link {
  color: #000;
  font-weight: bold;
  text-transform: uppercase;
  white-space:nowrap;
}
.main-header {
  font-size: 1.2rem;
  letter-spacing: 3px;
  text-transform: uppercase;
  font-weight: bold;
  color: #000000;
  position: absolute;
  left: 80px;
  top: 15px;
}
.main-header-mobile {
  font-size: 1.2rem;
  letter-spacing: 3px;
  text-transform: uppercase;
  font-weight: bold;
  color: #000000;
  position: absolute;
  left: calc(50% - 80px);
  top: 0;
}

@media (min-width: 992px) {
  .navbar-wrapper-inner {
    width: 100%;
    display: block;
    background-color: transparent !important;
    position: fixed;
  }
  .main-header {
    display: block;
    left: 20px;
    top: 155px;
  }
  .inner-header {
    width: 200px;
  }
  .main-header-mobile {
    display: none;
  }

  .nav-cart-wrapper {
    display: none;
  }
  .main-logo {
    top: 20px;
    width: 200px;
    left: 20px;
  }
  .nav-menu-options-close {
    display: block;
    // width: 100%;
    text-align: left;
    position: fixed;
    background-color: transparent;
    transform: translateX(0);
    opacity: 1;
  }
  .nav-menu-list {
    display: block;
    margin-left: 40px;
    margin-top: 220px;
  }
  .nav-menu-list-options {
    margin-left: 0 !important;
  }
  .link-text {
    color: #000000 !important;
    font-size: 1.1rem;
    cursor: pointer;
    padding: 0 0;
  }
  .link-text:hover span {
    text-decoration: underline;
    display: block;
  }
}
</style>
